(function () {
  "use strict";

  const SELECTORS = {
    mainCarousel: ".js-splide-top-main",
    productCarousel: ".js-splide_products",
    rankingButtons: ".v2-products-ranking .button",
    rankingItems: ".v2-products-ranking .items",
    categoriesAll: ".v2-categories-all",
  };

  const SPLIDE_CONFIG = {
    main: {
      autoplay: false,
      type: "loop",
      pagination: true,
      arrows: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      interval: 1000,
      speed: 300,
      perPage: 1,
      fixedWidth: "1080px",
      padding: "calc((100% - 1080px) / 2)",
      lazyLoad: "nearby",
      preloadPages: 1,
      flickPower: 300,
      gap: 10,
      breakpoints: {
        1080: {
          fixedWidth: "calc((350 / 390) * 100vw)",
          padding: "calc((20 / 390) * 100vw)",
          gap: 8,
          arrows: false,
        },
      },
    },
    product: {
      autoplay: false,
      type: "slide",
      pagination: false,
      arrows: true,
      interval: 1000,
      speed: 300,
      fixedWidth: 255,
      perPage: 1,
      drag: true,
      start: 0,
      breakpoints: {
        1080: {
          autoWidth: true,
          gap: 0,
          arrows: false,
        },
      },
    },
  };

  const initMainCarousel = () => {
    const mainCarousel = document.querySelector(SELECTORS.mainCarousel);
    if (!mainCarousel) return;

    const splide = new Splide(mainCarousel, SPLIDE_CONFIG.main);
    splide.mount();

    // Loop modeの初期位置ずれを修正（操作すると直る問題の対策）
    if (window.innerWidth >= 1080) {
      var fixPosition = function () {
        splide.refresh();
      };
      requestAnimationFrame(function () {
        requestAnimationFrame(fixPosition);
      });
      // 画像の遅延読み込み後にも再計算
      setTimeout(fixPosition, 150);
    }
  };

  const initProductCarousels = () => {
    const carousels = document.querySelectorAll(SELECTORS.productCarousel);
    if (carousels.length === 0 || typeof Splide === "undefined") return;

    var rootMarginPx = 200;

    function isInViewport(el) {
      var rect = el.getBoundingClientRect();
      var margin = rootMarginPx;
      return rect.top < window.innerHeight + margin && rect.bottom > -margin;
    }

    function mountCarousel(el) {
      if (!el || el.classList.contains("is-initialized")) return;
      var scrollY = window.scrollY;
      new Splide(el, SPLIDE_CONFIG.product).mount();
      if (Math.abs(window.scrollY - scrollY) > 1) {
        window.scrollTo(0, scrollY);
      }
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            mountCarousel(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: rootMarginPx + "px" },
    );

    carousels.forEach(function (el) {
      if (isInViewport(el)) {
        mountCarousel(el);
      } else {
        observer.observe(el);
      }
    });
  };

  const initRankingToggle = () => {
    const buttons = document.querySelectorAll(SELECTORS.rankingButtons);
    const items = document.querySelectorAll(SELECTORS.rankingItems);

    if (buttons.length === 0 || items.length === 0) return;

    const loadImagesInTab = (tabElement) => {
      if (!tabElement) return;
      const imgs = tabElement.querySelectorAll(
        ".product-card-default-thum-image",
      );
      imgs.forEach((img) => {
        if (!img.complete && img.src) {
          new Image().src = img.src;
          if (img.decode) {
            img.decode().catch(() => {});
          }
        }
      });
    };

    buttons.forEach((button, index) => {
      button.addEventListener("click", () => {
        buttons.forEach((btn) => btn.classList.remove("is-current"));
        items.forEach((item) => item.classList.remove("is-current"));

        button.classList.add("is-current");
        const activeTab = items[index];
        if (activeTab) {
          activeTab.classList.add("is-current");
          requestAnimationFrame(() => {
            if (window.themeV2?.resetProductCardImages) {
              window.themeV2.resetProductCardImages();
            }
            loadImagesInTab(activeTab);
            if (window.themeV2?.setSwipeProductCardImage) {
              window.themeV2.setSwipeProductCardImage();
            }
          });
        }
      });
    });
  };

  const initCategoriesAll = () => {
    const categoryExpand =
      window.themeV2?.categoryExpand || window.categoryExpand;
    if (typeof categoryExpand !== "function") return;

    categoryExpand(SELECTORS.categoriesAll);

    window.addEventListener(
      "resize",
      () => categoryExpand(SELECTORS.categoriesAll),
      { passive: true },
    );
  };

  const initialize = () => {
    initMainCarousel();
    initProductCarousels();
    initRankingToggle();
    initCategoriesAll();
  };

  document.addEventListener("DOMContentLoaded", initialize);
})();
